import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import PTOType from 'types/pto';
import moment from 'moment';

import { createPTO, updatePTO, deletePTO } from 'actionCreators/ptos';
import { EditableTable } from 'components/EditableTable';
import TimeOffTableRow from 'timeOffTableRow';
import ConflictingAppointmentModal from 'conflictingAppointmentModal';

import S from './styles.scss';

const CONFLICT_RE = /^conflicting appointment\(s\)$/i;
const DATE_FORMAT = 'MM/DD/YYYY';
const EMPTY_TABLE = (
  <div className={S.emptyTable}>
    <h4>No time off requests found</h4>
  </div>
);

class TimeOffTable extends React.Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.state = { conflict: {}, hasConflict: false, tempEntry: null };
  }

  checkForConflicts = (id) => {
    const pto = this.props.ptos.find(p => (p.id === id));
    const err = (pto.errors || {}).base || [];
    const hasConflict = err.length > 0 && CONFLICT_RE.test(err[0].error);
    this.setState({ hasConflict, conflict: hasConflict ? err[0] : {} });
  };

  createPTO = (pto) => {
    const { user } = this.props;
    let { parentID, parentKind } = this.props;
    if (this.props.isCrew) {
      parentID = pto.crew;
      parentKind = 'crews';
    }
    return this.props.createPTO(parentID, parentKind, { ...pto, added_by: user });
  }

  updatePTO = pto => this.props.updatePTO(pto.id, pto);

  handleSave = (pto) => {
    const assignee = { id: pto.crew, name: '', kind: '' };
    const startDate = moment(pto.start_date, DATE_FORMAT).format();
    const endDate = moment(pto.end_date, DATE_FORMAT).format();
    const params = { assignee, ...pto, start_date: startDate, end_date: endDate };
    const req = pto.id === 'new' ? this.createPTO(params) : this.updatePTO(params);
    if (this.state.tempEntry) req.then(() => this.handleModalClose());
    else req.then(() => this.checkForConflicts(pto.id));
  }

  handleDelete = pto => (pto.id !== 'new' ? this.props.deletePTO(pto.id) : null);

  handleModalOpen = pto => this.setState({ hasConflict: true, tempEntry: pto });

  handleModalClose = () => this.setState({ hasConflict: false, tempEntry: null });

  renderRows = () => {
    const { ptos, crews, isCrew, parentObj, user } = this.props;
    if (ptos.length === 0 || ptos[0].id !== 'new') {
      ptos.unshift({ id: 'new', start_date: '', end_date: '', reason: '', crew: '' });
    }
    return ptos.map(pto => (<TimeOffTableRow
      key={pto.id}
      pto={pto}
      handleModalOpen={this.handleModalOpen}
      onSave={this.handleSave}
      onDelete={this.handleDelete}
      crews={crews}
      isCrew={isCrew}
      parentObj={parentObj}
      user={user}
    />));
  }

  render = () => (<div className={S.timeOffTable}>
    <EditableTable isEditable={this.props.isEditable} emptyNode={EMPTY_TABLE}>
      {this.renderRows()}
    </EditableTable>
    <ConflictingAppointmentModal
      active={this.state.hasConflict}
      dates={this.state.conflict.dates || []}
      tempEntry={this.state.tempEntry}
      onSubmit={this.props.parentKind === 'estimators' ?
        () => this.handleSave(this.state.tempEntry) : () => {}}
      onClose={this.handleModalClose}
    />
  </div>);
}

TimeOffTable.propTypes = {
  crews: PropTypes.array,
  isCrew: PropTypes.bool,
  isEditable: PropTypes.bool,
  ptos: PropTypes.arrayOf(PTOType),
  parentID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  parentKind: PropTypes.string.isRequired,
  parentObj: PropTypes.object,
  createPTO: PropTypes.func.isRequired,
  updatePTO: PropTypes.func.isRequired,
  deletePTO: PropTypes.func.isRequired,
  user: PropTypes.object,
};

TimeOffTable.defaultProps = {
  crews: [],
  isCrew: false,
  isEditable: false,
  ptos: [],
  parentObj: null,
};

export default connect(
  state => ({ user: state.user.name }),
  { createPTO, updatePTO, deletePTO },
)(TimeOffTable);



// WEBPACK FOOTER //
// ./client/app/shared/components/TimeOffTable/index.jsx